import { decorate, observable } from 'mobx';
import ListData from '../toolkit/mobx-connectors/observables/list-data';

class FacturaStore {
  list = new ListData();
}

decorate(FacturaStore, {
  list: observable
});

const facturaStore = new FacturaStore();
export default facturaStore;
